<template>
  <div class="fg-contest">
    <loading-state :state="state"></loading-state>
    <div v-if="state.isLoaded()" class="content">
      <div class="main">
        <div class="one info">
          <router-link :to="{name: 'FGContest', params:{key:contest.key}}">
            <h2 class="title">{{contest.name}}</h2>
          </router-link>
          <p v-if="contest.desc">{{contest.desc}}</p>
          <div class="links">
          </div>
        </div>
        <div class="two">
          <div class="sport-icon">
            <img v-if="contest.sport.isCricket" src="@/assets/imgs/batsman-ready.png" />
            <img v-else-if="contest.sport.isFootball" src="@/assets/imgs/sport-football.svg" />
          </div>
        </div>
      </div>
      <div class="section contest-items">
        <div class="item item-rule">
          <div>
            <svg-icon icon-name="rule" class="rule-icon head-icon"></svg-icon>
          </div>
          <div class="card inv">
            <RulePreview
              :rule="contest.rule"
              :contestKey="contest.key"></RulePreview>
          </div>
        </div>

        <div class="item item-rewards-pointsystem">
          <div class="item-rewards">
            <div>
              <svg-icon icon-name="rewards" class="rewards-icon head-icon"></svg-icon>
            </div>
            <div class="card inv">
              <RewardsPreview
                :rewards="contest.rewards"
                :contestKey="contest.key"></RewardsPreview>
            </div>
          </div>

          <div class="item-pointsystem">
            <!-- <div>
              <svg-icon icon-name="pointsystem" class="pointsystem-icon head-icon"></svg-icon>
            </div> -->
            <div class="card inv">
              <PointsystemPreview
                :pointsystem="contest.pointsystem"
                :contestKey="contest.key"></PointsystemPreview>
            </div>
          </div>
        </div>
      </div>

      <div class="section contest-games-leaderboard">
        <div class="item contest-games">
          <div>
            <svg-icon icon-name="game" class="game-icon head-icon"></svg-icon>
          </div>
          <div class="">
            <h2 class="section-title">Games</h2>
            <loading-state :state="stateGames"></loading-state>
            <div class="games" v-if="stateGames.isLoaded()">
              <div
                v-for="preview in games"
                :key="preview.game.key"
              >
                <game-preview
                  :contest="contest"
                  :game="preview.game"
                  :preview="preview"
                  ></game-preview>
              </div>
              <div>
                <Pagination @loadContent="loadContent" :isGame="true" :pagination="fullContestObj" v-if="fullContestObj.total > 5"></Pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="item contest-leaderboard-main">
          <div>
            <svg-icon icon-name="pointsystem" class="pointsystem-icon head-icon"></svg-icon>
          </div>
          <div>
            <h2 class="section-title">Leaderboard</h2>
            <ContestLeaderboard :contestKey="contest.key"/>
            <h2 class="section-title">Team Leaderboard</h2>
            <GroupLeaderboard :contestKey="contest.key"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { Contest } from '@/models/fantasygame/core'
import GamePreview from '@/components/fantasygame/GamePreview'
import RulePreview from '@/components/fantasygame/RulePreview'
import RewardsPreview from '@/components/fantasygame/RewardsPreview'
import PointsystemPreview from '@/components/fantasygame/PointsystemPreview'
import ContestLeaderboard from '@/components/fantasygame/ContestLeaderboard'
import GroupLeaderboard from '@/components/fantasygame/GroupLeaderboard'
import Pagination from '@/components/cricket/Pagination'

export default {
  components: {
    GamePreview,
    RulePreview,
    RewardsPreview,
    PointsystemPreview,
    ContestLeaderboard,
    Pagination,
    GroupLeaderboard
  },
  data () {
    return {
      key: this.$route.params.key,
      contest: null,
      games: [],
      fullContestObj: null,
      gamesCursor: null,
      state: DataState.newLoading(),
      stateGames: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },

  methods: {
    onViewOpenned () {
      this.key = this.$route.params.key

      Contest.detail(this.key).then((resp) => {
        this.contest = resp
        this.state.changeToLoaded()
        return Contest.games(this.contest.key)
      }).then((resp) => {
        this.games = resp.previews
        this.gamesCursor = resp.cursor
        this.fullContestObj = resp
        this.stateGames.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    prepareToReopen () {
      this.contest = null
      this.state = DataState.newLoading()
    },

    loadContent (e) {
      Contest.games(this.contest.key, e).then((resp) => {
        this.games = resp.previews
        this.gamesCursor = resp.cursor
        this.fullContestObj = resp
        this.stateGames.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    refreshView () {
      this.games = []
      this.gamesCursor = null
    }
  }
}
</script>
